// NotificationViewPage.jsx
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Card, Row, Col, Button, Tag, Spin, Alert, Typography } from 'antd';
import { EditOutlined, LeftOutlined } from '@ant-design/icons';
import { getNotificationById } from '../../services/notifications';
import '../../styles/global.css';
import usePermissions from '../../hooks/usePermissions';
const NotificationViewPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { Title } = Typography;
  const { can } = usePermissions();
  
  const [loading, setLoading] = useState(true);
  const [notification, setnotification] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!id) {
      setError('ID de notificación no proporcionado');
      setLoading(false);
      return;
    }

    const loadNotification = async () => {
      try {
        setLoading(true);
        setError(null);
        const notificationData = await getNotificationById(id);
        setnotification(notificationData);
      } catch (err) {
        console.error('Error al cargar notificación:', err);
        setError('No se pudo cargar la información de la notificación');
      } finally {
        setLoading(false);
      }
    };

    loadNotification();
  }, [id]);

  const handleEdit = () => {
    navigate(`/notifications/${id}/edit`);
  };

  const handleBack = () => {
    navigate('/notifications/all');
  };

  if (loading) {
    return (
      <div style={{ padding: 24, display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 400 }}>
        <Spin size="large" />
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ padding: 24 }}>
        <Alert
          message="Error"
          description={error}
          type="error"
          showIcon
          action={
            <Button size="small" onClick={handleBack}>
              Volver
            </Button>
          }
        />
      </div>
    );
  }

  if (!notification) {
    return (
      <div style={{ padding: 24 }}>
        <Alert
          message="Notificación no encontrada"
          description="La notificación no existe o no se pudo cargar."
          type="warning"
          showIcon
          action={
            <Button size="small" onClick={handleBack}>
              Volver
            </Button>
          }
        />
      </div>
    );
  }

  return (
    <div style={{ padding: 24, margin: '0 auto' }}>
      {/* Header */}
      <div style={{ marginBottom: 24, display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <Button 
            type="text" 
            icon={<LeftOutlined style={{ fontSize: '24px', strokeWidth: 4 }} />} 
            style={{ 
              padding: 0,
              color: '#BA955E',
              fontSize: '24px',
              fontWeight: '700',
              height: 'auto'
            }}
            onClick={handleBack}
          />
          <Title level={3} style={{ marginBottom: 0 }}>Detalles de la notificación</Title>
        </div>

        {can('notifications.edit') && (<Button 
          type="text" 
          icon={<EditOutlined style={{ fontSize: '24px', strokeWidth: 4 }} />} 
          onClick={handleEdit}
          style={{ 
            padding: 0,
            color: '#262626',
            fontSize: '24px',
            fontWeight: '100',
            height: 'auto'
          }}
        />)}
      </div>

      <Card
        style={{
          borderRadius: '32px',
          boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
        }}
      >


      <Row gutter={16}>
          <Col xs={24} md={18}>
            <Row gutter={16}>
              <Col xs={24} md={8} className='col-spaced'>
                <div className="field-label">
                  Notificación
                </div>
                <div className="field-value">
                  {notification.notification?.description || 'No disponible'}
                </div>
              </Col>
              <Col xs={24} md={8} className='col-spaced'>
                <div className="field-label">
                  Módulo
                </div>
                <div className="field-value">
                  {notification.module.description || 'No disponible'}
                </div>
              </Col>
              <Col xs={24} md={8} className='col-spaced'>
                <div className="field-label">
                  Perfil
                </div>
                <div className="field-value">
                  {notification.notificationDetailRoles && notification.notificationDetailRoles.length > 0
                  ? notification.notificationDetailRoles
                      .map((r) => r.role.description || r.role.name)
                      .join(', ')
                  : 'No disponible'}
                </div>
              </Col>

              <Col xs={24} md={12} className='col-spaced'>
                <div className="field-label">
                  Correo Electrónico
                </div>
                <div className="field-value">
                  {notification.email || 'No disponible'}
                </div>
              </Col>

              <Col xs={24} md={12} className='col-spaced'>
                <div className="field-label">
                  ¿Incluir Copia Oculta?
                </div>
                <div className="field-value">
                  <Tag color={notification.hidden_copy ? 'green' : 'volcano'}>
                    {notification.hidden_copy ? 'Sí' : 'No'}
                  </Tag>
                </div>
              </Col>
            </Row> 
          </Col>
        </Row> 
      </Card>
    </div>
  );
};

export default NotificationViewPage;